import { type PaginationParams } from '@webapp/core/providers/Pagination/pagination.types'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { getMileageLockSettingUseCase } from '../business-logic/use-cases/GetMileageLockSetting'
import { expenseRepository } from '../data-access/repositories/ExpenseRepository'
import { type ExpenseStatusEnum } from '../entities/enums/ExpenseStatusEnum'

const base = ['expense']

export const expenseQueryConfig = {
  // Plain array literal (not buildQueryKey): `status` can be undefined, and
  // buildQueryKey would truncate the key there and drop `params`.
  summaries: (status?: ExpenseStatusEnum, params?: PaginationParams) => ({
    queryKey: [...base, 'list', status, params],
    queryFn: () => expenseRepository.list(status, params),
  }),
  drafts: () => ({
    queryKey: buildQueryKey([...base, 'drafts']),
    queryFn: () => expenseRepository.getDrafts(),
  }),
  requestFormData: () => ({
    queryKey: buildQueryKey([...base, 'request-form-data']),
  }),
  mileageLockSetting: () => ({
    queryKey: buildQueryKey([...base, 'mileage-lock-setting']),
    queryFn: () => getMileageLockSettingUseCase.execute(),
  }),
}
